import React, {Component} from 'react';

import Page from './component/page/page'

import {BrowserRouter, HashRouter} from 'react-router-dom'
import {env} from './platform/env'
import {push} from './platform/push'

class Gmair extends Component {
    componentDidMount() {
        if (env.is_native()) {
            push.registerPush();
            const cap = env.getCapacitor();
            if (cap && cap.Plugins && cap.Plugins.StatusBar) {
                cap.Plugins.StatusBar.setStyle({style: 'DARK'}).catch(() => {});
            }
        }
    }

    render() {
        // Capacitor / file:// needs HashRouter; WeChat H5 keeps BrowserRouter
        const Router = env.is_native() ? HashRouter : BrowserRouter;
        return (
            <Router>
                <Page></Page>
            </Router>
        );
    }
}

export default Gmair;
